module.exports = __webpack_public_path__ + "img/shot_tx19112101.a0d54f94.jpg";